import styled from 'styled-components'
import styledMap from 'styled-map'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { gap, GapProps } from 'Services/Styles'

type Props = MarginProps & LayoutProps & GapProps

const colorMap = styledMap({
  default: themeGet('colors.primary.main'),
})

const hoverColorMap = styledMap({
  default: themeGet('colors.primary.dark'),
})

const fontSizeMap = styledMap({
  default: 20,
})

const LinkButton = styled.button<Props>`
  padding: 0 ${themeGet('space.5')}px;
  font-family: inherit;
  font-size: ${fontSizeMap}px;
  font-weight: ${themeGet('fontWeights.1')};
  letter-spacing: -0.2px;
  text-transform: capitalize;
  color: ${colorMap};
  box-shadow: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${hoverColorMap};
  }

  &:disabled {
    cursor: default;
    opacity: 30%;
    color: ${colorMap};

    &:hover {
      color: ${colorMap};
    }
  }

  ${margin}
  ${layout}
  ${gap}
`

export default LinkButton
